import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewPagamentoVenda from "../views/ViewPagamentoVenda";





const PagamentoVenda: React.FC = () => (
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

      <ViewPagamentoVenda/>
      

      <ViewFooter />
    </div>
  </>
);
export default PagamentoVenda;

